module.exports = __webpack_public_path__ + "img/hr-dead-tree-desert-05.61098371.png";